import { atom } from 'jotai'

export const companiesAtom = atom([])
export const companyAtom = atom({})